module.exports = __webpack_public_path__ + "img/dl_logo.bea19c9c.png";